import { Descriptions as AntdDescriptions } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ImCheckmark, ImCross } from "react-icons/im";
import { useNavigate, useParams } from "react-router-dom";
import AppContext from "../../../context/app/context";
import GeneralSettingContext from "../../../context/general-setting/context";
import GeneralSettingContextProvider from "../../../context/general-setting/provider";
import Descriptions from "../../general/antd/descriptions";
import Spin from "../../general/antd/spin";
import PageDetails from "../../general/details";
import OldImage from "../../form-components/old-image";

interface Props { }

const GeneralSetting: React.FC<Props> = () => {
    const { t } = useTranslation();
    const { direction } = useContext(AppContext);
    const { list, actions, loading } = useContext(GeneralSettingContext);
    const { id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        const getGeneralSetting = async () => {
            await actions.getGeneralSetting();
        };
        getGeneralSetting();
    }, [direction]);
    return (
        <>
            <PageDetails
                navigate
                title={t("details")}
                subtitle={t("general_settings")}
                buttonName={`${t("update_general_settings")}`}
                onClick={() => navigate(`/general-settings/update`)}
            >
                {loading.includes("list") ? (
                    <Spin />
                ) : (
                    <Descriptions size="small" column={2} bordered>
                        <AntdDescriptions.Item label={t("welcome_message")}>
                            {list?.welcomeMessage}
                        </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("we_are")}>
                            {list?.weAre}
                        </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("our_achievements")}>
                            {list?.ourAchievements}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("welcomeMessageActivation")}>
                            {list?.welcomeMessageActivation ? (
                                <ImCheckmark color="green" />
                            ) : (
                                <ImCross color="red" />
                            )}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("facebook")}>
                            {list?.facebook ?? "--"}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("instagram")}>
                            {list?.instagram ?? "--"}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("phone")}>
                            {list?.phone ?? "--"}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("hotLine")}>
                            {list?.hotLine ?? "--"}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("telegram")}>
                            {list?.telegram ?? "--"}
                        </AntdDescriptions.Item>

                        <AntdDescriptions.Item label={t("whatsApp")}>
                            {list?.whatsApp ?? "--"}
                        </AntdDescriptions.Item>
                    </Descriptions>
                )}
            </PageDetails>
        </>
    );
};

const GeneralSettingDetailsPage = () => {
    return (
        <GeneralSettingContextProvider>
            <GeneralSetting />
        </GeneralSettingContextProvider>
    );
};
export default GeneralSettingDetailsPage;
